import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Edit3($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M13 21h8" }],

		[
			"path",

			{
				"d": "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
			}
		]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiRWRpdDMuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCBJY29uIGZyb20gJy4vSWNvbi5zdmVsdGUnO1xuICBjb25zdCBpY29uTm9kZTogW3N0cmluZywgUmVjb3JkPHN0cmluZywgc3RyaW5nPl1bXSA9IFtbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTEzIDIxaDhcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0yMS4xNzQgNi44MTJhMSAxIDAgMCAwLTMuOTg2LTMuOTg3TDMuODQyIDE2LjE3NGEyIDIgMCAwIDAtLjUuODNsLTEuMzIxIDQuMzUyYS41LjUgMCAwIDAgLjYyMy42MjJsNC4zNTMtMS4zMmEyIDIgMCAwIDAgLjgzLS40OTd6XCIgfV1dO1xuICBsZXQgcmVzdCA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48SWNvbiB7aWNvbk5vZGV9IHsuLi5yZXN0fSAvPlxuIl0sIm1hcHBpbmdzIjoiOztPQUNTLElBQUksTUFBTSxlQUFlOztpREFEbEMsQ0FBQztPQUVPLFFBQTRDO0dBQUssTUFBTSxJQUFJLEdBQUcsRUFBRSxVQUFVOzs7R0FBTSxNQUFNOzs7SUFBSSxHQUFHLEVBQUUsa0lBQWtJOzs7OztLQUNuTyxJQUFJOzs7Ozs7OztRQUVXLElBQUk7O0FBRDFCLENBQUMifQ==